import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FilterPill } from '@zola/zola-ui/src/components/FilterPill';
import { handleOptionClick, trimPillsData } from '../CommonShopFilters/helpers';

import './FilterPillList.less';

const FilterPillList = ({
  onClearAll,
  onFilterSelect,
  selectedFilters,
  setFilters,
  filterList,
  isMobile,
}) => {
  // Max limit of non-truncated pills for a mobile version
  const PILL_TRUNCATED_LIMIT = 3;
  // A counter for a hidden pills CTA
  const hiddenFilters = PILL_TRUNCATED_LIMIT + 1;

  const [pillsTruncated, setPillsTruncated] = useState(false);
  const [pillFull, setPillFull] = useState(false);

  const pillsDataArray = trimPillsData({ filterList, selectedFilters });

  const handlePillClick = (category, option) => {
    handleOptionClick(onFilterSelect, selectedFilters, setFilters, category, option);
  };
  /**
   * Toggle the pill's view between truncated and full view
   * */
  const togglePills = () => {
    setPillFull(!pillFull);
  };

  const pills = pillsDataArray.map(({ label, value, name }, index) => {
    const customClass = index > PILL_TRUNCATED_LIMIT && isMobile ? 'pill-hidden' : '';
    return (
      <FilterPill
        key={index}
        apiKeyName={name}
        handlePillClick={() => handlePillClick(name, value)}
        label={label}
        value={value}
        customClass={customClass.length > 0 ? customClass : ''}
      />
    );
  });

  useEffect(() => {
    if (isMobile) {
      // eslint-disable-next-line no-unused-expressions
      pillsDataArray.length <= PILL_TRUNCATED_LIMIT
        ? setPillsTruncated(false)
        : setPillsTruncated(true);
    }
  }, [pillsDataArray.length, pills]);

  const containerClass = cx('pill-container', pillFull ? 'pill-expanded' : '');

  return pillsDataArray.length > 0 ? (
    <div className="main-pill-wrapper">
      <div id="js-pills-container" className={containerClass}>
        {isMobile && (
          <span className="pill-clear-all" onClick={onClearAll}>
            Clear all
          </span>
        )}
        {pills}
        {!isMobile && (
          <div className="pill-clear-all" onClick={onClearAll}>
            Clear all
          </div>
        )}
      </div>
      {pillsTruncated && pillsDataArray.length - 1 > PILL_TRUNCATED_LIMIT && isMobile && (
        <span className="pill-clear-all" onClick={togglePills}>
          {!pillFull ? `+ ${pillsDataArray.length - hiddenFilters} Filters` : 'Show Less'}
        </span>
      )}
    </div>
  ) : (
    <Fragment />
  );
};

FilterPillList.propTypes = {
  onClearAll: PropTypes.func.isRequired,
  onFilterSelect: PropTypes.func,
  setFilters: PropTypes.func,
  isMobile: PropTypes.bool,
  selectedFilters: PropTypes.shape([]),
  filterList: PropTypes.shape({}),
};

export default FilterPillList;
